<template>
  <div>
    <el-dialog
      class="f-model"
      :show-close="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :width="width"
      :visible.sync="visible"
      destroy-on-close
      :top="top"
      @close="close"
    >
      <a
        v-if="showclose"
        class="close pinter"
        :class="{ outsize: closeoutsize }"
        @click="close"
        ><i class="iconfont icon-fanbaiquxiao"></i
      ></a>
      <slot name="body"> </slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'fModel',
  props: {
    visible: {
      default: false
    },
    closeoutsize: {
      default: false
    },
    showclose: {
      default: true
    },
    width: {
      default: '480px'
    },
    top: {
      default: '15vh'
    }
  },
  data() {
    return {

    };
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss">
.f-model {
  .el-dialog {
    background: transparent;
  }
  .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0);
    backdrop-filter: blur(6px);
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0px;
    .close {
      color: #d8d8d8;
      i {
        font-size: 26px;
      }
      position: absolute;
      z-index: 2;
      right: 18px;
      top: 18px;
      &.outsize {
        right: -33px;
        top: -16px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/fModel/index.vue